import React from "react";

import { IBasketLine } from "../../../models/catalogue.interfaces";
import { BasketLineImage } from "./BasketLineImage";
import { BasketLineOptions } from "./BasketLineOptions";
import { BasketLineQuantity } from "./BasketLineQuantity";
import { BasketLineTitle } from "./BasketLineTitle";

export const BasketLineMinimal = (props: {
    line: IBasketLine;
}): React.ReactNode => (
    <li>
        <div
            className="basket-line basket-line--minimal"
            role="group"
            aria-label="product"
        >
            <div className="basket-line__graphic">
                <BasketLineImage product={props.line.product} />
            </div>
            <div className="basket-line__details">
                <div className="basket-line__details__row">
                    <BasketLineTitle product={props.line.product} />
                    <BasketLineQuantity quantity={props.line.quantity} />
                </div>
                <div className="basket-line__details__row">
                    <BasketLineOptions product={props.line.product} />
                </div>
            </div>
        </div>
    </li>
);
